import ContextMissingError from "@errors/ContextMissingError"
import { createContext, useContext } from "react"

const SalonAcceptancesContext = createContext<Jury.Contexts.SalonAcceptances | null>(null)
const useSalonAcceptancesContext = () => { 
    const context = useContext(SalonAcceptancesContext)
    if (!context) throw new ContextMissingError()
    return context
}

export { useSalonAcceptancesContext }
export default SalonAcceptancesContext